import {
  actions as edgeActions
} from '../../../ducks/resource-edges';
import {
  actions as nodeActions
} from '../../../ducks/resource-nodes';
import { actions } from '../../../ducks/uploads';
import { clearParentResourceUploads } from '../v1/clearParentResourceUploads';
import { handleDisposeResource } from '../v1/handleDisposeResource';
import { handleMutateManyResourceEdges } from '../v1/handleMutateManyResourceEdges';
import { handleTree } from '../v1/handleTree';
import { uploadFilesToParentResource } from './uploadFilesToParentResource';

/**
 * Upload-Middleware takes files from the action and runs a set of steps
 * required to update the ui and stay compatible with legacy cube upload-server
 *
 */
export const uploadsMiddleware =
  ({ getState, dispatch }) =>
    (next) =>
      (action) => {
        const workspaceId = getState().session.workspace;

        switch (action.type) {
          case actions.UPLOAD_WITH_FOLDER_STRUCTURE: {
            handleTree(
              action.payload.parentFolderId,
              action.payload.tree,
              action.payload.metadata,
              dispatch,
              getState,
              workspaceId
            );
            break;
          }
          case actions.UPLOAD_FILES_TO_FOLDER: {
            console.info('DEBUG action', action);
            uploadFilesToParentResource({ dispatch, getState, workspaceId, action })
            return next(action);
          }

          case actions.UPLOAD_FILES_TO_PARENT_RESOURCE: {
            console.info('DEBUG action', action);
            uploadFilesToParentResource({ dispatch, getState, workspaceId, action, edgeLabel: 'attachments' })
            return next(action);
          }

          case actions.CLEAR_PARENT_RESOURCE_UPLOADS: {
            clearParentResourceUploads({ dispatch, getState, action });

            return next(action);
          }

          case edgeActions.MUTATE_MANY_RESOURCE_EDGES: {
            handleMutateManyResourceEdges({ getState, dispatch, action });
            return next(action);
          }

          case nodeActions.DISPOSE_RESOURCE: {
            handleDisposeResource({ getState, dispatch, action });
            return next(action);
          }
          default:
            // Call the next dispatch method in the middleware chain.
            return next(action);
        }
      };
